/**************************************************
 * Nombre:       BarraCell
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Badge, Collapse, Grid, Typography} from "@mui/material";
import logo from '../../Recursos/logo_blaco_redondo.png'
import {theme} from "../../Tema";
import {Category, Search, ShoppingBag, ShoppingCart} from '@mui/icons-material'
import IconoTexto from "./Componentes/IconoTexto";
import {useContext, useState} from "react";
import BarraBusqueda from "./Componentes/BarraBusqueda";
import {contexData} from "../../App";
import {useNavigate} from "react-router-dom";
import {useCarritoCompras} from "../../Modulo_Carrito_Wass/Hooks/useCarritoCompras";
import {useFuncionesCarrito} from "../../Modulo_Carrito_Wass/Hooks/useFuncionesCarrito";


const BarraCell = () => {
    const cData = useContext(contexData)
    const navigate = useNavigate()
    const {abrir, DialogoCarrito} = useCarritoCompras()
    const {productos} = useFuncionesCarrito()
    const [open, setOpen] = useState(false)


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}} sx={{py: 1, backgroundColor: theme.palette.primary.main, px: 2}}>

            <DialogoCarrito/>

            <Grid container size={{xs: 2, sm: 1, md: 11}} sx={{justifyContent: 'center'}}>
                <IconoTexto Icono={Category} texto={'categorias'} click={() => cData.setOpenCategorias(true)}/>
            </Grid>

            <Grid container size={{xs: 2, sm: 1, md: 11}} sx={{justifyContent: 'center'}}>
                <IconoTexto Icono={Search} texto={'Busqueda'} click={() => setOpen(!open)}/>
            </Grid>

            <Grid container size={{xs: 4, sm: 8, md: 12}} justifyContent={'center'}>
                <img src={logo} width={54} height={'auto'} onClick={() => {
                    cData.setSubCatEscogida('')
                    cData.setIconoCat('')
                    navigate('/')
                }}/>
            </Grid>

            <Grid container size={{xs: 2, sm: 1, md: 11}} sx={{justifyContent: 'center'}}>
                <IconoTexto Icono={ShoppingBag} texto={'Ult. Compras'} click={() => navigate('/Mis_Compras')}/>
            </Grid>

            <Grid container size={{xs: 2, sm: 1, md: 11}} sx={{justifyContent: 'center'}}>


                <Grid
                    onClick={() => abrir()}
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{fill: '#fff', color: '#fff'}}
                >


                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                        <Badge color={'secondary'} badgeContent={productos.length} anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }} >
                            <ShoppingCart/>
                        </Badge>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                        <Typography sx={{fontSize: 10, textAlign: 'center', lineHeight: 1.1}}>{'Carrito'}</Typography>
                    </Grid>

                </Grid>

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Collapse in={open} sx={{width: '100%'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{py: 1}}
                    >

                        <BarraBusqueda/>


                    </Grid>

                </Collapse>
            </Grid>


        </Grid>
    )

}
export default BarraCell